import { render, staticRenderFns } from "./RealEstateRentContracts30.vue?vue&type=template&id=23057b0e&"
import script from "./RealEstateRentContracts30.vue?vue&type=script&lang=js&"
export * from "./RealEstateRentContracts30.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateRentContracts30.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports